declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID?.trim();
let initialized = false;

export const isAnalyticsEnabled = (): boolean => Boolean(measurementId);

export const initAnalytics = (): void => {
  if (!isAnalyticsEnabled() || initialized) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId as string)}`;
  script.dataset.analytics = "ga4";
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];

  const gtag = (...args: unknown[]) => {
    window.dataLayer.push(args);
  };

  window.gtag = window.gtag || gtag;
  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });

  initialized = true;
};

export const trackPageView = (pagePath: string): void => {
  if (!isAnalyticsEnabled()) {
    return;
  }

  if (!initialized) {
    initAnalytics();
  }

  if (typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", "page_view", {
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
  });
};
